module.exports = __webpack_public_path__ + "static/und-tangara-48c5db5274e2a2ddb2b85f6714b4ebf1.png";